/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable sonarjs/no-use-of-empty-return-value */
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Col, Row, Table } from 'antd';
import * as Yup from 'yup';
import { PropTypes } from 'prop-types';
import { Form } from 'formik-antd';
import { Formik } from 'formik';
import moment from 'moment';
import { getClientList } from 'store/clientSlice';
import { Box, Button, CustomInput, FormInput, Text } from 'atoms';
import { updateVendorBill } from 'store/vendorBillSlice';
import { getVendorBillDetailsV2, updateVendorBillV2 } from 'store/vendorBillSliceV2';
import { getUIVersion } from 'utils/router-static-data';
import { AntdTable } from 'components/custom-table/Style';
import { CancelButton } from 'utils/commonStyled';
import ProformaPdfViewerModal from 'pages/vendor/vendor-invoice/components/ProformaPdfViewerModal';

const Container = styled(Box)`
	background-color: #f4f4f4;
	padding: 24px;
	font-weight: 300;
`;

const TitleText = styled(Text)`
	font-size: 26px;
	font-weight: 600;
	line-height: 50px;
`;

const SubTitle = styled(Text)`
	font-size: 20px;
	font-weight: 400;
	line-height: 30px;
	margin-bottom: 16px;
`;

const Tag = styled(Text)`
	font-weight: 400;
	margin-right: 10px;
`;

const Card = styled(Box)`
	background-color: #fff;
	border-radius: 8px;
	border-top: 2px solid #2f8ecb;
	margin-bottom: 16px;
	padding: 24px;
`;

const PayableCard = styled(Box)`
	background-color: #fff;
	border-radius: 8px;
	border-top: 2px solid #2f8ecb;
	margin-bottom: 16px;
	padding: 24px;
	width: 50%;
`;

const RowsData = styled(Row)`
	background: #ccc;
	padding: 5px;
	margin: 5px -8px;
`;
const Rows1Data = styled(Row)`
	padding: 5px;
	margin: 5px;
`;
const Flex = styled(Box)`
	display: flex;
`;

const FlexChild = styled(Box)`
	flex-grow: 1;
	flex-basis: 50%;
`;

const FormSchema = Yup.object({
	deduction_amount: Yup.string()
		.nullable()
		.matches(
			/^\d*(\.\d{0,2})?$/,
			'Deduction Amount should be a Number (No Special Character and only 2 decimal place allowed)'
		)
		.label('Deduction Amount'),
	extra_km: Yup.string()
		.nullable()
		.matches(
			/^\d*(\.\d{0,2})?$/,
			'Extra Km should be a Number (No Special Character and only 2 decimal place allowed)'
		)
		.label('Extra Km'),
	extra_hr: Yup.string()
		.nullable()
		.matches(
			/^\d*(\.\d{0,2})?$/,
			'Extra Hr should be a Number (No Special Character and only 2 decimal place allowed)'
		)
		.label('Extra Hr'),
	labour_charge: Yup.string()
		.nullable()
		.matches(
			/^\d*(\.\d{0,2})?$/,
			'Labour Charge should be a Number (No Special Character and only 2 decimal place allowed)'
		)
		.label('Labour Charge'),
	toll_charge: Yup.string()
		.nullable()
		.matches(
			/^\d*(\.\d{0,2})?$/,
			'Toll Charge should be a Number (No Special Character and only 2 decimal place allowed)'
		)
		.label('Toll Charge'),
	miscellaneous_charges: Yup.string()
		.nullable()
		.matches(
			/^\d*(\.\d{0,2})?$/,
			'Miscellaneous Charges should be a Number (No Special Character and only 2 decimal place allowed)'
		)
		.label('Miscellaneous Charges'),
	unloading_charges: Yup.string()
		.nullable()
		.matches(
			/^\d*(\.\d{0,2})?$/,
			'Unloading Charges should be a Number (No Special Character and only 2 decimal place allowed)'
		)
		.label('Unloading Charges'),
	halt_charges: Yup.string()
		.nullable()
		.matches(
			/^\d*(\.\d{0,2})?$/,
			'Halt Charges should be a Number (No Special Character and only 2 decimal place allowed)'
		)
		.label('Halt Charges'),
	gst: Yup.string()
		.nullable()
		.matches(
			/^\d*(\.\d{0,2})?$/,
			'GST should be a Number (No Special Character and only 2 decimal place allowed)'
		)
		.label('GST'),
	remark: Yup.string(),
});

const columnsRegularTrip = [
	{
		title: 'Driver ',
		dataIndex: 'driver_username',
		key: 'driver_username',
	},
	{
		title: 'Per Trip Cost',
		dataIndex: 'per_trip_cost',
		key: 'per_trip_cost',
	},
	{
		title: 'No of Trips',
		dataIndex: 'no_of_trips',
		key: 'no_of_trips',
	},
	{
		title: 'Amount',
		dataIndex: 'total_cost',
		key: 'total_cost',
	},
	{
		title: 'TDS Rate',
		dataIndex: 'tds_rate',
		key: 'tds_rate',
	},
	{
		// eslint-disable-next-line sonarjs/no-duplicate-string
		title: 'TDS Amount',
		dataIndex: 'tds_amount',
		key: 'tds_amount',
	},
];

const columnsAdhocTrip = [
	{
		title: 'Vehicle Type',
		dataIndex: 'vehicle_type',
		key: 'vehicle_type',
	},
	{
		title: 'Vehicle Rate',
		dataIndex: 'vehicle_rate',
		key: 'vehicle_rate',
	},
	{
		title: 'No Of Trips',
		dataIndex: 'no_of_trips',
		key: 'no_of_trips',
	},
	{
		title: 'Total Amount',
		dataIndex: 'total_cost',
		key: 'total_cost',
	},
	{
		title: 'TDS Rate',
		dataIndex: 'tds_rate',
		key: 'tds_rate',
	},
	{
		title: 'TDS Amount',
		dataIndex: 'tds_amount',
		key: 'tds_amount',
	},
];

const columnsNoLoadTrip = [
	{
		title: 'Driver',
		dataIndex: 'driver_username',
		key: 'driver_username',
	},
	{
		title: 'No Load Trip Charge',
		dataIndex: 'noload_trip_charge',
		key: 'noload_trip_charge',
	},
	{
		title: 'No Of Trips',
		dataIndex: 'no_of_trips',
		key: 'no_of_trips',
	},
	{
		title: 'Total Amount',
		dataIndex: 'total_cost',
		key: 'total_cost',
	},
	{
		title: 'TDS Rate',
		dataIndex: 'tds_rate',
		key: 'tds_rate',
	},
	{
		title: 'TDS Amount',
		dataIndex: 'tds_amount',
		key: 'tds_amount',
	},
];

const getAdvancePaymentColumns = (onViewPdf) => [
	{
		title: 'Trip Id',
		dataIndex: 'trip_id',
		key: 'trip_id',
		render: (value) => value || '-',
	},
	{
		title: 'UTR Number',
		dataIndex: 'advance_utr_number',
		key: 'advance_utr_number',
		render: (value) => value || '-',
	},
	{
		title: 'Proforma Invoice No',
		dataIndex: 'proforma_invoice_number',
		key: 'proforma_invoice_number',
		render: (value) => value || '-',
	},
	{
		title: 'Proforma PDF',
		key: 'proforma_pdf',
		render: (_, record) =>
			record.proforma_view_url ? (
				<span
					style={{ cursor: 'pointer', color: '#d32f2f', fontSize: '18px' }}
					title="View Proforma PDF"
					onClick={() => onViewPdf(record)}
					role="button"
					tabIndex={0}
					onKeyDown={(e) => e.key === 'Enter' && onViewPdf(record)}
				>
					📄
				</span>
			) : (
				'-'
			),
	},
	{
		title: 'Advance Amount',
		dataIndex: 'advance_amount',
		key: 'advance_amount',
		render: (value) => (value !== undefined && value !== null && value !== '' ? value : '-'),
	},
];

const formatVendorAddress = (address) => {
	if (!address) return '-';
	if (typeof address === 'string') return address;
	if (typeof address === 'object') {
		return [address.zone, address.city, address.state, address.pincode]
			.filter(Boolean)
			.join(', ');
	}
	return '-';
};

export default function VendorBillEditForm({ formData = {} }) {
	const { id } = useParams();
	const navigate = useNavigate();
	const uiVersion = getUIVersion();
	const useV2API = uiVersion === 'new';
	console.log(formData);
	const [vendorBillRes, setVendorBillRes] = useState({});
	const [total_amounts, setTotalAmountval] = useState('');
	const [regularTripData, setRegularTripData] = useState([]);
	const [adhocTripData, setAdhocTripData] = useState([]);
	const [noLoadTripData, setNoLoadTripData] = useState([]);
	const [FinalAmt, setFinalAmt] = useState('');
	const [pdfViewRecord, setPdfViewRecord] = useState(null);
	const dispatch = useDispatch();

	const isGstRegistered = vendorBillRes?.vendor_details?.is_gst_registered === true;
	useEffect(() => {
		if (id) {
			const action = useV2API
				? getVendorBillDetailsV2({ id })
				: getClientList({
						search_type: 'vendor_bill_details',
						filter_by: {
							id,
							is_editable: true,
						},
				  });

			dispatch(action).then((res) => {
				console.log('res', res);
				setVendorBillRes(res?.data?.vendor_bill);
				getTotalAmount(res.data.vendor_bill, res.data.total_advance_amount);
				setRegularTripData(res?.data?.regular_trips_bill);
				setAdhocTripData(res?.data?.adhoc_trips_bill);
				setNoLoadTripData(res?.data?.noload_trips_bill);

				if (res) {
					setVendorBillRes(res.data);
				} else {
					setVendorBillRes([]);
					setRegularTripData([]);
					setAdhocTripData([]);
					setNoLoadTripData([]);
				}
			});
		}
	}, [dispatch, id, useV2API]);

	const getTotal = (values, total) => {
		console.log(values);
		const totalAmt =
			Number(total) +
			Number(values?.extra_km || 0) +
			Number(values?.extra_hr || 0) +
			Number(values?.toll_charge || 0) +
			Number(values?.labour_charge || 0) +
			Number(values?.miscellaneous_charges || 0) +
			Number(values?.unloading_charges || 0) +
			Number(values?.halt_charges || 0) -
			Number(values?.deduction_amount);
		console.log(totalAmt);
		const int_part = Math.trunc(totalAmt); // returns 3
		const float_part = Number((totalAmt - int_part).toFixed(2));
		console.log(float_part);
		console.log(Math.ceil(Number(totalAmt)));
		console.log(Math.round(Number(totalAmt)));
		if (float_part <= 0.5) {
			setFinalAmt(Math.floor(Number(totalAmt)));
			return Math.floor(Number(totalAmt));
		}
		setFinalAmt(Math.ceil(Number(totalAmt)));
		return Math.ceil(Number(totalAmt));
	};

	function getTotalAmount(vendor_bill, total_advance_amount) {
		console.log(vendor_bill);
		const totalAfterdedection =
			Number(vendor_bill?.bill_amount) -
			(Number(vendor_bill?.tds_amount) + Number(total_advance_amount));
		console.log(totalAfterdedection);
		setTotalAmountval(totalAfterdedection);
	}

	const getAdvancePaymentSummary = (advancePaymentData) => {
		const totalAdvanceAmount = advancePaymentData?.reduce(
			(sum, record) => sum + (Number(record.advance_amount) || 0),
			0
		);
		return (
			<Table.Summary.Row>
				<Table.Summary.Cell index={0}>
					<strong>Total</strong>
				</Table.Summary.Cell>
				<Table.Summary.Cell index={1} />
				<Table.Summary.Cell index={2} />
				<Table.Summary.Cell index={3} />
				<Table.Summary.Cell index={4}>
					<strong>₹ {totalAdvanceAmount}</strong>
				</Table.Summary.Cell>
			</Table.Summary.Row>
		);
	};

	const getAdvancePaymentData = (tripData) => {
		if (!Array.isArray(tripData)) return [];
		return tripData.flatMap((item) =>
			Array.isArray(item.advance_payments) ? item.advance_payments : []
		);
	};

	const initialValues = useMemo(
		() => ({
			deduction_amount: formData?.deduction_amount || 0,
			extra_km: formData?.extra_km_charges || 0,
			extra_hr: formData?.extra_hr_charges || 0,
			labour_charge: formData?.labour_charges || 0,
			toll_charge: formData?.toll_amount || 0,
			miscellaneous_charges: formData?.miscellaneous_charges || 0,
			unloading_charges: formData?.unloading_charges || 0,
			halt_charges: formData?.halt_charges || 0,
			gst: formData?.gst || 0,
			remark: '',
		}),
		[formData]
	);

	const handleSubmit = (values) => {
		const deduction_payalod = Number(values?.deduction_amount);
		console.log(deduction_payalod);
		const payloadData = {
			id,
			skip_validation: true,
			deduction_amount: Number(values.deduction_amount),
			extra_hr_charges: Number(values.extra_hr),
			extra_km_charges: Number(values.extra_km),
			labour_charges: Number(values.labour_charge),
			toll_amount: Number(values.toll_charge),
			miscellaneous_charges: Number(values.miscellaneous_charges),
			unloading_charges: Number(values.unloading_charges),
			halt_charges: Number(values.halt_charges),
			total_payable_amount: Math.round(Number(FinalAmt)),
		};

		// Only send GST when vendor is GST registered (matches backend expectation).
		if (isGstRegistered) {
			payloadData.gst = Number(values?.gst || 0);
		}

		const updateAction = useV2API
			? updateVendorBillV2({ req_data: payloadData })
			: updateVendorBill({
					data: {
						update_type: 'vendor_bill',
						data: payloadData,
					},
			  });

		dispatch(updateAction)
			.then((res) => {
				console.log(res);
				window.location.replace(`${window.origin}/vendor-bill-invoice/${res.data.id}`);
			})
			.catch(() => {});
	};

	return (
		<Formik
			initialValues={initialValues}
			validationSchema={FormSchema}
			onSubmit={handleSubmit}
			enableReinitialize
		>
			{({ values, error }) => (
				<Container>
					{console.log(values, error)}
					<Form>
						<TitleText>Vendor Bill Editing</TitleText>
						<Card>
							<Flex>
								<FlexChild>
									<Flex mb={3}>
										<Tag>Bill No:</Tag>
										<Text>{vendorBillRes?.vendor_bill?.vendor_bill_no}</Text>
									</Flex>
									<Flex mb={3}>
										<Tag>Bill Date :</Tag>
										<Text>
											{moment
												.utc(vendorBillRes?.vendor_bill?.created_date)
												.local()
												.format('DD-MM-YYYY h:mm A')}
										</Text>
									</Flex>
								</FlexChild>
								<FlexChild>
									<Flex mb={3}>
										<Tag>Pay To:</Tag>
										<Text>
											{vendorBillRes?.vendor_details?.vendor_name} ,{' '}
											{formatVendorAddress(
												vendorBillRes?.vendor_details?.address
											)}
										</Text>
									</Flex>
									<Flex mb={3}>
										<Tag>Invoice To:</Tag>
										<Text>
											Intelligent Retail Pvt Ltd <br />
											G Floor, 413/C,
											<br />
											15th Cross Rd, Muneswara Nagar, Sector 6,
											<br />
											HSR Layout, Bengaluru, Karnataka-560102, India
											<br />
											GSTIN Number: 29AAFCI1726B1ZW
										</Text>
									</Flex>
								</FlexChild>
							</Flex>
							<SubTitle>Vendor Details</SubTitle>
							<Flex>
								<FlexChild>
									<Flex mb={3}>
										<Tag>PAN:</Tag>
										<Text>{vendorBillRes?.vendor_details?.pan_number}</Text>
									</Flex>
									<Flex mb={3}>
										<Tag>Bank:</Tag>
										<Text>{vendorBillRes?.vendor_details?.bank_name}</Text>
									</Flex>
									<Flex mb={3}>
										<Tag>Account No:</Tag>
										<Text>{vendorBillRes?.vendor_details?.acc_number}</Text>
									</Flex>
								</FlexChild>
								<FlexChild>
									<Flex mb={3}>
										<Tag>GSTIN:</Tag>
										<Text>{vendorBillRes?.vendor_details?.gst_number}</Text>
									</Flex>
									<Flex mb={3}>
										<Tag>Bank Branch:</Tag>
										<Text>{vendorBillRes?.vendor_details?.bank_branch}</Text>
									</Flex>
									<Flex mb={3}>
										<Tag>IFSC Code:</Tag>
										<Text>{vendorBillRes?.vendor_details?.ifsc_code}</Text>
									</Flex>
								</FlexChild>
							</Flex>
							<SubTitle>Invoice Details</SubTitle>
							<Flex>
								<FlexChild>
									<Flex mb={3}>
										<Tag>Project Location:</Tag>
										<Text>
											{vendorBillRes?.project_location_codes?.join(',  ')}
										</Text>
									</Flex>
									<Flex mb={3}>
										<Tag>No.Of Trips.:</Tag>
										<Text>{vendorBillRes?.vendor_bill?.no_of_trips}</Text>
									</Flex>
								</FlexChild>
								<FlexChild>
									<Flex mb={3}>
										<Tag>Bill Period.:</Tag>
										<Text>{vendorBillRes?.vendor_bill?.bill_period}</Text>
									</Flex>
									<Flex mb={3}>
										<Tag>Invoice Payment Status:</Tag>
										<Text>{vendorBillRes?.vendor_bill?.invoice_status}</Text>
									</Flex>
								</FlexChild>
								<FlexChild>
									<Flex mb={3}>
										<Tag>Invoice UTR No.:</Tag>
										<Text>{vendorBillRes?.vendor_bill?.utr_number}</Text>
									</Flex>
								</FlexChild>
							</Flex>
						</Card>
						{(() => {
							const advancePaymentData = getAdvancePaymentData(adhocTripData);
							const hasAdvancePayment = advancePaymentData?.length > 0;
							return (
								hasAdvancePayment && (
									<Card>
										<Flex>
											<FlexChild>
												<SubTitle>Advance Details</SubTitle>
												<Table
													dataSource={advancePaymentData}
													columns={getAdvancePaymentColumns((rec) =>
														setPdfViewRecord(rec)
													)}
													pagination={false}
													summary={() =>
														getAdvancePaymentSummary(advancePaymentData)
													}
												/>
											</FlexChild>
										</Flex>
									</Card>
								)
							);
						})()}
						<ProformaPdfViewerModal
							visible={Boolean(pdfViewRecord)}
							onClose={() => setPdfViewRecord(null)}
							viewUrl={pdfViewRecord?.proforma_view_url}
							invoiceNumber={pdfViewRecord?.proforma_invoice_number}
							pdfFilename={pdfViewRecord?.proforma_pdf_url}
						/>
						{regularTripData?.length > 0 && (
							<Card>
								<SubTitle>Regular Trip Details</SubTitle>
								<Box mt={3}>
									<AntdTable
										dataSource={regularTripData}
										columns={columnsRegularTrip}
									/>
								</Box>
							</Card>
						)}

						{adhocTripData?.length > 0 && (
							<Card>
								<SubTitle>Adhoc Trip Details</SubTitle>
								<Box mt={3}>
									<AntdTable
										dataSource={adhocTripData}
										columns={columnsAdhocTrip}
									/>
								</Box>
							</Card>
						)}

						{noLoadTripData?.length > 0 && (
							<Card>
								<SubTitle>No Load Trip Details</SubTitle>
								<Box mt={3}>
									<AntdTable
										dataSource={noLoadTripData}
										columns={columnsNoLoadTrip}
									/>
								</Box>
							</Card>
						)}

						<PayableCard>
							<SubTitle>Total Payable</SubTitle>
							<RowsData gutter={16} justify="space-between">
								<Col lg={12}>Regualr Trip Payment :</Col>
								{console.log(vendorBillRes)}
								<Col lg={12}> {vendorBillRes?.vendor_bill?.bill_amount || 0}</Col>
							</RowsData>
							<Rows1Data gutter={16} justify="space-between">
								<Col lg={12}>Advance Amount :</Col>
								<Col lg={12}> - {vendorBillRes?.total_advance_amount || 0}</Col>
							</Rows1Data>
							<RowsData>
								<Col lg={12}>TDS Amount :</Col>
								<Col lg={12}> - {vendorBillRes?.vendor_bill?.tds_amount || 0}</Col>
							</RowsData>
							<Rows1Data gutter={16} justify="space-between">
								<Col lg={12}>Deduction Amount - </Col>
								<Col lg={12}>
									<FormInput name="deduction_amount">
										<CustomInput
											name="deduction_amount"
											disabled={!vendorBillRes?.is_editable}
										/>
									</FormInput>
								</Col>
							</Rows1Data>
							<Rows1Data gutter={16} justify="space-between">
								<Col lg={12}>Extra KM Charge</Col>
								<Col lg={12}>
									<FormInput name="extra_km">
										<CustomInput
											name="extra_km"
											disabled={!vendorBillRes?.is_editable}
										/>
									</FormInput>
								</Col>
							</Rows1Data>
							<Rows1Data gutter={16} justify="space-between">
								<Col lg={12}>Extra HR Charge</Col>
								<Col lg={12}>
									<FormInput name="extra_hr">
										<CustomInput
											name="extra_hr"
											disabled={!vendorBillRes?.is_editable}
										/>
									</FormInput>
								</Col>
							</Rows1Data>
							<Rows1Data gutter={16} justify="space-between">
								<Col lg={12}>Labour Charges</Col>
								<Col lg={12}>
									<FormInput name="labour_charge">
										<CustomInput
											name="labour_charge"
											disabled={!vendorBillRes?.is_editable}
										/>
									</FormInput>
								</Col>
							</Rows1Data>
							<Rows1Data gutter={16} justify="space-between">
								<Col lg={12}>Toll Charges</Col>
								<Col lg={12}>
									<FormInput name="toll_charge">
										<CustomInput
											name="toll_charge"
											disabled={!vendorBillRes?.is_editable}
										/>
									</FormInput>
								</Col>
							</Rows1Data>
							<Rows1Data gutter={16} justify="space-between">
								<Col lg={12}>Miscellaneous Charges</Col>
								<Col lg={12}>
									<FormInput name="miscellaneous_charges">
										<CustomInput
											name="miscellaneous_charges"
											disabled={!vendorBillRes?.is_editable}
										/>
									</FormInput>
								</Col>
							</Rows1Data>
							<Rows1Data gutter={16} justify="space-between">
								<Col lg={12}>Unloading Charges</Col>
								<Col lg={12}>
									<FormInput name="unloading_charges">
										<CustomInput
											name="unloading_charges"
											disabled={!vendorBillRes?.is_editable}
										/>
									</FormInput>
								</Col>
							</Rows1Data>
							<Rows1Data gutter={16} justify="space-between">
								<Col lg={12}>Halt Charges</Col>
								<Col lg={12}>
									<FormInput name="halt_charges">
										<CustomInput
											name="halt_charges"
											disabled={!vendorBillRes?.is_editable}
										/>
									</FormInput>
								</Col>
							</Rows1Data>
							<Rows1Data gutter={16} justify="space-between">
								<Col lg={12}>Deduction Remark</Col>
								<Col lg={12}>
									<FormInput name="remark">
										<CustomInput
											name="remark"
											disabled={!vendorBillRes?.is_editable}
										/>
									</FormInput>
								</Col>
							</Rows1Data>
							<Rows1Data gutter={16} justify="space-between">
								<Col lg={12}>GST (18%)</Col>
								<Col lg={12}>
									<FormInput name="gst">
										<CustomInput
											name="gst"
											disabled={
												!vendorBillRes?.is_editable || !isGstRegistered
											}
										/>
									</FormInput>
								</Col>
							</Rows1Data>
							<Rows1Data gutter={16} justify="space-between">
								<Col lg={12}>Total Payable Amount : </Col>
								<Col lg={12}>{getTotal(values, total_amounts)}</Col>
							</Rows1Data>
							<Rows1Data gutter={16} justify="space-between">
								<Col lg={12}>Grand Total : </Col>
								<Col lg={12}>
									{(
										getTotal(values, total_amounts) + Number(values?.gst || 0)
									).toFixed(2)}
								</Col>
							</Rows1Data>
						</PayableCard>
						<Box backgroundColor="#f5f5f5" textAlign="right" padding="1.5rem">
							<CancelButton
								onClick={() => navigate('/vendor-invoices')}
								type="button"
							>
								Cancel
							</CancelButton>
							<Button borderRadius="4px" backgroundColor="#18405d" type="submit">
								Submit
							</Button>
						</Box>
					</Form>
				</Container>
			)}
		</Formik>
	);
}

VendorBillEditForm.propTypes = {
	formData: PropTypes.object,
};
